var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIbmSettingsAdjust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1875 5H18.75V6.25H16.1875C15.875 7.6875 14.625 8.75 13.125 8.75C11.625 8.75 10.375 7.6875 10.0625 6.25H1.25V5H10.0625C10.375 3.5625 11.625 2.5 13.125 2.5C14.625 2.5 15.875 3.5625 16.1875 5ZM11.25 5.625C11.25 6.6875 12.0625 7.5 13.125 7.5C14.1875 7.5 15 6.6875 15 5.625C15 4.5625 14.1875 3.75 13.125 3.75C12.0625 3.75 11.25 4.5625 11.25 5.625ZM3.8125 15H1.25V13.75H3.8125C4.125 12.3125 5.375 11.25 6.875 11.25C8.375 11.25 9.625 12.3125 9.9375 13.75H18.75V15H9.9375C9.625 16.4375 8.375 17.5 6.875 17.5C5.375 17.5 4.125 16.4375 3.8125 15ZM8.75 14.375C8.75 13.3125 7.9375 12.5 6.875 12.5C5.8125 12.5 5 13.3125 5 14.375C5 15.4375 5.8125 16.25 6.875 16.25C7.9375 16.25 8.75 15.4375 8.75 14.375Z",
    fill: "#868E96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmSettingsAdjust);
export default __webpack_public_path__ + "static/media/IBMSettingsAdjust.0c21243c.svg";
export { ForwardRef as ReactComponent };